import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#clip0_2119_9743)" }, [
      _createElementVNode("path", {
        fill: "#58A1D5",
        d: "M12 24C5.387 24 0 18.623 0 12 0 5.388 5.388 0 12 0c6.623 0 12 5.388 12 12 0 6.623-5.377 12-12 12m-.624-10.73a.76.76 0 0 0-.565.224l-1.235 1.294-.47.506.035-.577v-7.87c0-.435-.33-.765-.789-.765-.458 0-.8.33-.8.765v7.859l.012.588-.435-.506-1.247-1.27c-.165-.154-.341-.248-.565-.248a.754.754 0 0 0-.776.777c0 .188.094.4.247.576l2.988 3.036c.33.34.824.317 1.141 0l2.988-3.036a.9.9 0 0 0 .236-.576c0-.459-.318-.777-.765-.777m7.788-3.906-2.953-3.047c-.317-.317-.87-.317-1.176 0l-2.988 3.047c-.13.165-.224.377-.224.565 0 .46.318.788.765.788a.74.74 0 0 0 .564-.247l1.236-1.27.47-.494-.035.564v7.86c0 .446.353.788.8.788a.76.76 0 0 0 .788-.789V9.282l-.012-.565.436.483 1.247 1.27a.76.76 0 0 0 .565.247c.458 0 .776-.329.776-.788a.81.81 0 0 0-.259-.565"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "clip0_2119_9743" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M24 0v24H0V0z"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }